import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import React from "react";

import { css } from "@emotion/react";

import { PremiumBadge } from "./PremiumBadge";
import { SegmentIconWithLabel } from "./segment-icon-with-label";
import { DealerDto } from "@swo/salesforce-service";
import { fontColor, fontSize } from "../../../styles/fonts";

export const DealerCardMainInfo: ReactTFC<{
  headline: React.ReactNode;
  isPremium: boolean;
  segment: DealerDto["segment"] | undefined;
  onClick?: () => void;
  translations: {
    birdingLabel: string;
    huntingLabel: string;
    outdoorLabel: string;
    premiumLabel: string;
  };
}> = props => {
  return (
    <>
      <button css={dealerNameStyles} onClick={props.onClick}>
        {props.headline}
      </button>

      <div css={wrapperStyles}>
        {props.segment && (
          <SegmentIconWithLabel segment={props.segment} cropped={true} translations={props.translations} />
        )}

        {props.isPremium && <PremiumBadge>{props.translations.premiumLabel}</PremiumBadge>}
      </div>
    </>
  );
};

const wrapperStyles = css`
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: space-between;

  margin-bottom: 20px;

  > * + * {
    margin-left: 8px;
  }
`;

const dealerNameStyles = [
  fontColor.black,
  fontSize.x2,
  css`
    text-transform: uppercase;
    text-align: left;

    margin-bottom: 10px;
  `,
];
